// extracted by mini-css-extract-plugin
export default {"ssoLoading":"ssoLoading---a2A5o"};